import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import AppCtrl from "../../../control/AppCtrl";
import Config from '../../../utils/Config';
import LANGUAGE_TYPE from "../../../utils/Language";
import GiftRecordsPage from "./GiftRecordsPage";
import PlayRecordsPage from "./PlayRecordsPage";
import EFunction from '../../../utils/FunctionPage';
import switchFunc from '../../../redux/switchFunc/switchFuncAction';

import moment from 'moment';
import DatePicker from '../../../component/_component/DatePicker';
import Buuton from '../../../component/_component/Button';

function RecordsPage() {
    const text = Config.text.recordsPage;
    const { setFunc } = switchFunc();
    const navigate = useNavigate();

    //===========================================================================
    const [recordsTitle, setRecordsTitle] = useState(null);
    const [userGiftList, setUserGiftList] = useState(null);
    const [userActionList, setUserActionList] = useState(null);

    const [startDateTime, setStartDateTime] = useState(moment().subtract(6, 'days'));
    const [endDateTime, setEndDateTime] = useState(moment());

    useEffect(() => {
        componentDidMount();
        return componentWillUnmount;
    }, []);
    //===========================================================================

    function componentDidMount() {
        window.addEventListener('resize', onResize);
        onResize();

        if (Config.showGiftRecords) setRecordsTitle(text.giftRecords);
        else if (Config.showPlayRecords) setRecordsTitle(text.playRecords);
    }

    function componentWillUnmount() {
        window.removeEventListener('resize', onResize);
    }

    function onResize() {
        const deviceHeight = window.innerHeight;

        const uiPlayRecordsPage = document.getElementById('playRecordsPage');
        if (uiPlayRecordsPage) {
            uiPlayRecordsPage.style.height = `${deviceHeight}px`;
            uiPlayRecordsPage.style.overflowY = "auto";
        }
    }

    const onBack = useCallback(() => {
        //AppCtrl.askMachineTokenInLobby();
        setFunc(EFunction.winLobby);
        // navigate('/lobby');
    }, [])

    const onQueryRecords = useCallback(() => {
        if (startDateTime && endDateTime) {
            //console.log("startDateTime:", startDateTime.format("YYYY-MM-DD HH:mm:ss"));
            //console.log("endDateTime:", endDateTime.value?.format?.("YYYY-MM-DD HH:mm:ss") || endDateTime.value);
            let sTime = startDateTime.toDate();
            //let eTime = moment(endDateTime.value).endOf('day').toDate();
            let eTime = endDateTime.endOf('day').toDate();
            
            if (recordsTitle == text.giftRecords) {
                AppCtrl.getUserGiftRecords(sTime, eTime, function (resObj) {
                    if (resObj.status == "success") {
                        const giftList = resObj.content;
                        setUserGiftList(giftList);
                    }
                });
            }
            else if (recordsTitle == text.playRecords) {
                AppCtrl.getUserPlayRecords(sTime, eTime, function (resObj) {
                    if (resObj.status == "success" && resObj.userActionList) {
                        const actionList = [];
                        for (let i = 0; i < resObj.userActionList.length; i++) {
                            const action = JSON.parse(resObj.userActionList[i]);
                            actionList.push(action);
                        }
                        setUserActionList(actionList);
                    }
                });
            }
        }
    }, [startDateTime, endDateTime, recordsTitle])

    const onGiftRecords = useCallback(() => {
        setRecordsTitle(text.giftRecords);
    }, [])

    const onPlayRecords = useCallback(() => {
        setRecordsTitle(text.playRecords);
    }, [])

    const startDateTimeChange = useCallback((e) => {
        setStartDateTime(moment(e.target.value));
    }, [])

    const endDateTimeChange = useCallback((e) => {
        setEndDateTime(moment(e.target.value));
    }, [])

    return (
        <div className={styles.recordsPage}>
            <div className={styles.functionPanel}>
                {
                    Config.showGiftRecords && <Buuton
                        text={text.giftRecords}
                        onClick={onGiftRecords}
                        className={`small blue ${styles.btn}`}
                    />
                }
                {
                    Config.showPlayRecords && <Buuton
                        text={text.playRecords}
                        onClick={onPlayRecords}
                        className={`small blue ${styles.btn}`}
                    />
                }
            </div>
            <hr></hr>
            <h3>{`${recordsTitle}`}</h3>
            <div className={styles.queryPanel}>
                <div className={styles.timeContainer}>
                    <DatePicker text={text.timefrom} value={startDateTime} onChange={startDateTimeChange} />
                    <DatePicker text={text.timeend} value={endDateTime} onChange={endDateTimeChange} />
                </div>
                <div className={styles.buttonContainer}>
                    <Buuton
                        text={text.btnRecordBack}
                        onClick={onBack}
                        className={`large red ${styles.btn}`}
                    />
                    <Buuton
                        text={text.btnRecordQuery}
                        onClick={onQueryRecords}
                        className={`large green ${styles.btn}`}
                    />
                </div>
            </div>
            <hr></hr>
            {
                recordsTitle == text.giftRecords ? <GiftRecordsPage records={userGiftList} /> : null
            }
            {
                recordsTitle == text.playRecords ? <PlayRecordsPage records={userActionList} /> : null
            }
        </div>
    );
}

export default RecordsPage;